import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/**
 * API para gestionar declaraciones IR-13 (Retenciones ISR anuales - DGII)
 */
export const ir13API = {
  /**
   * Obtener todas las declaraciones IR-13 de una empresa
   * @param {string} companyId
   * @returns {Promise<{ ir13s: Array }>}
   */
  getAll: async (companyId) => {
    try {
      const response = await axios.get(`${API_URL}/ir13`, {
        params: { companyId },
        headers: getAuthHeader(),
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Generar una nueva declaración IR-13
   * @param {string} companyId
   * @param {number} anio - Año fiscal
   * @param {boolean} incluirInactivos - Si se incluyen empleados inactivos
   * @returns {Promise<{ ir13: Object }>}
   */
  generar: async (companyId, anio, incluirInactivos = false) => {
    try {
      const response = await axios.post(
        `${API_URL}/ir13/generar`,
        { companyId, anio, incluirInactivos },
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Obtener una declaración IR-13 por ID
   * @param {string} id
   * @returns {Promise<{ ir13: Object }>}
   */
  getById: async (id) => {
    try {
      const response = await axios.get(`${API_URL}/ir13/${id}`, {
        headers: getAuthHeader(),
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Obtener el detalle por empleado de una declaración IR-13
   * @param {string} id
   * @returns {Promise<{ detalles: Array }>}
   */
  getDetalles: async (id) => {
    try {
      const response = await axios.get(`${API_URL}/ir13/${id}/detalles`, {
        headers: getAuthHeader(),
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Cerrar una declaración IR-13 y generar saldos
   * @param {string} id
   * @returns {Promise<{ ir13: Object, saldos_generados: number, advertencias: Array }>}
   */
  cerrar: async (id) => {
    try {
      const response = await axios.post(
        `${API_URL}/ir13/${id}/cerrar`,
        {},
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Eliminar una declaración IR-13
   * @param {string} id
   * @returns {Promise<Object>}
   */
  eliminar: async (id) => {
    try {
      const response = await axios.delete(`${API_URL}/ir13/${id}`, {
        headers: getAuthHeader(),
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default ir13API;
